/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'

const VaultLazyRouteImport = createFileRoute('/vault')()
const ConfigureIrmLazyRouteImport = createFileRoute('/configure-irm')()
const AddressBookLazyRouteImport = createFileRoute('/address-book')()
const IndexLazyRouteImport = createFileRoute('/')()
const OracleIndexLazyRouteImport = createFileRoute('/oracle/')()
const OracleRouterAddressLazyRouteImport = createFileRoute(
  '/oracle/$routerAddress',
)()
const MdKeyLazyRouteImport = createFileRoute('/md/$key')()
const ManageVaultVaultAddressLazyRouteImport = createFileRoute(
  '/manage-vault/$vaultAddress',
)()

const VaultLazyRoute = VaultLazyRouteImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/vault.lazy').then((d) => d.Route))
const ConfigureIrmLazyRoute = ConfigureIrmLazyRouteImport.update({
  id: '/configure-irm',
  path: '/configure-irm',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/configure-irm.lazy').then((d) => d.Route))
const AddressBookLazyRoute = AddressBookLazyRouteImport.update({
  id: '/address-book',
  path: '/address-book',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/address-book.lazy').then((d) => d.Route))
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const OracleIndexLazyRoute = OracleIndexLazyRouteImport.update({
  id: '/oracle/',
  path: '/oracle/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/oracle/index.lazy').then((d) => d.Route))
const OracleRouterAddressLazyRoute = OracleRouterAddressLazyRouteImport.update({
  id: '/oracle/$routerAddress',
  path: '/oracle/$routerAddress',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/oracle/$routerAddress.lazy').then((d) => d.Route),
)
const MdKeyLazyRoute = MdKeyLazyRouteImport.update({
  id: '/md/$key',
  path: '/md/$key',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/md/$key.lazy').then((d) => d.Route))
const ManageVaultVaultAddressLazyRoute =
  ManageVaultVaultAddressLazyRouteImport.update({
    id: '/manage-vault/$vaultAddress',
    path: '/manage-vault/$vaultAddress',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/manage-vault/$vaultAddress.lazy').then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/address-book': typeof AddressBookLazyRoute
  '/configure-irm': typeof ConfigureIrmLazyRoute
  '/vault': typeof VaultLazyRoute
  '/manage-vault/$vaultAddress': typeof ManageVaultVaultAddressLazyRoute
  '/md/$key': typeof MdKeyLazyRoute
  '/oracle/$routerAddress': typeof OracleRouterAddressLazyRoute
  '/oracle/': typeof OracleIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/address-book': typeof AddressBookLazyRoute
  '/configure-irm': typeof ConfigureIrmLazyRoute
  '/vault': typeof VaultLazyRoute
  '/manage-vault/$vaultAddress': typeof ManageVaultVaultAddressLazyRoute
  '/md/$key': typeof MdKeyLazyRoute
  '/oracle/$routerAddress': typeof OracleRouterAddressLazyRoute
  '/oracle': typeof OracleIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/address-book': typeof AddressBookLazyRoute
  '/configure-irm': typeof ConfigureIrmLazyRoute
  '/vault': typeof VaultLazyRoute
  '/manage-vault/$vaultAddress': typeof ManageVaultVaultAddressLazyRoute
  '/md/$key': typeof MdKeyLazyRoute
  '/oracle/$routerAddress': typeof OracleRouterAddressLazyRoute
  '/oracle/': typeof OracleIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/address-book'
    | '/configure-irm'
    | '/vault'
    | '/manage-vault/$vaultAddress'
    | '/md/$key'
    | '/oracle/$routerAddress'
    | '/oracle/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/address-book'
    | '/configure-irm'
    | '/vault'
    | '/manage-vault/$vaultAddress'
    | '/md/$key'
    | '/oracle/$routerAddress'
    | '/oracle'
  id:
    | '__root__'
    | '/'
    | '/address-book'
    | '/configure-irm'
    | '/vault'
    | '/manage-vault/$vaultAddress'
    | '/md/$key'
    | '/oracle/$routerAddress'
    | '/oracle/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AddressBookLazyRoute: typeof AddressBookLazyRoute
  ConfigureIrmLazyRoute: typeof ConfigureIrmLazyRoute
  VaultLazyRoute: typeof VaultLazyRoute
  ManageVaultVaultAddressLazyRoute: typeof ManageVaultVaultAddressLazyRoute
  MdKeyLazyRoute: typeof MdKeyLazyRoute
  OracleRouterAddressLazyRoute: typeof OracleRouterAddressLazyRoute
  OracleIndexLazyRoute: typeof OracleIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vault': {
      id: '/vault'
      path: '/vault'
      fullPath: '/vault'
      preLoaderRoute: typeof VaultLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configure-irm': {
      id: '/configure-irm'
      path: '/configure-irm'
      fullPath: '/configure-irm'
      preLoaderRoute: typeof ConfigureIrmLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/address-book': {
      id: '/address-book'
      path: '/address-book'
      fullPath: '/address-book'
      preLoaderRoute: typeof AddressBookLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oracle/': {
      id: '/oracle/'
      path: '/oracle'
      fullPath: '/oracle/'
      preLoaderRoute: typeof OracleIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oracle/$routerAddress': {
      id: '/oracle/$routerAddress'
      path: '/oracle/$routerAddress'
      fullPath: '/oracle/$routerAddress'
      preLoaderRoute: typeof OracleRouterAddressLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/md/$key': {
      id: '/md/$key'
      path: '/md/$key'
      fullPath: '/md/$key'
      preLoaderRoute: typeof MdKeyLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage-vault/$vaultAddress': {
      id: '/manage-vault/$vaultAddress'
      path: '/manage-vault/$vaultAddress'
      fullPath: '/manage-vault/$vaultAddress'
      preLoaderRoute: typeof ManageVaultVaultAddressLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AddressBookLazyRoute: AddressBookLazyRoute,
  ConfigureIrmLazyRoute: ConfigureIrmLazyRoute,
  VaultLazyRoute: VaultLazyRoute,
  ManageVaultVaultAddressLazyRoute: ManageVaultVaultAddressLazyRoute,
  MdKeyLazyRoute: MdKeyLazyRoute,
  OracleRouterAddressLazyRoute: OracleRouterAddressLazyRoute,
  OracleIndexLazyRoute: OracleIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
